module.exports = __webpack_public_path__ + "img/lightbulb.13510ebd.svg";